"use client";

import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FlexBox from "@v2/components/styled/FlexBox";
import TextOverflow from "@v2/components/styled/TextOverflow";
import { numberFormat } from "@v2/helpers/optimizedHelpers";

// The text half of a product card: brand, title, code and price. Shared by the
// slider's product slides and the product-tabs cards.

// Live data is only for product / site_product
export interface LandingPageLiveData {
    main_title: string | null;
    rest_title: string | null;
    // Only site_product slides resolve a variant, so product slides leave this out.
    media_id?: string | null;
    has_quantity: number | null;
    rial_price: number;
    discount: number;
    discount_expire_at: string | null;
    final_price: number;
    need_inquiry: boolean;
    brand_fa: string | null;
    brand_en: string | null;
    tag: string | null;
}

const ProductCardBody = ({ liveData }: {
    liveData: LandingPageLiveData
}) => {
    const discountPercent = liveData.rial_price
        ? Math.round((liveData.discount / liveData.rial_price) * 100)
        : 0;
    const hasDiscount = discountPercent > 0;
    const noPrice = !liveData.rial_price;

    return (
        <Box sx={{ p: { xs: '8px 10px 12px', sm2: '15px 16px 18px' }, display: 'flex', flexDirection: 'column', userSelect: 'none', bgcolor: '#fff' }}>
            {liveData.brand_en && (
                <Box sx={{
                    fontSize: 11.5,
                    fontWeight: 700,
                    letterSpacing: '1px',
                    color: '#bb202e',
                    textTransform: 'uppercase',
                    mb: 0.75,
                }}>
                    {liveData.brand_en}
                </Box>
            )}
            <TextOverflow sx={{ fontSize: { xs: 13, sm2: 14 }, fontWeight: 600, lineHeight: 1.55, color: '#2a2a2a' }}>
                {liveData.main_title}
            </TextOverflow>
            {liveData.rest_title && (
                <TextOverflow dir="ltr" className="en-num" sx={{
                    fontSize: 11.5,
                    color: '#9a9a9f',
                    mt: 0.5,
                    // fontFamily: 'monospace',
                    letterSpacing: '0.5px',
                }}>
                    {liveData.rest_title}
                </TextOverflow>
            )}

            <Box sx={{
                mt: 'auto',
                pt: 0,
                minHeight: { xs: 38, sm2: 42 },
                display: 'flex',
                alignItems: 'flex-end',
            }}>
                {liveData.need_inquiry ? (
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#0f8df4' }}>
                        قیمت با استعلام
                    </Typography>
                ) : (
                    <FlexBox sx={{ alignItems: 'flex-end', justifyContent: 'space-between', gap: 1 }}>
                        <Box>
                            <Box sx={{
                                height: 17,
                                fontSize: 12,
                                color: '#b3b3b8',
                                fontWeight: 600,
                                textDecoration: 'line-through',
                                visibility: hasDiscount && !noPrice ? 'visible' : 'hidden',
                            }}>
                                {numberFormat(liveData.rial_price / 10)}
                            </Box>
                            <FlexBox sx={{ alignItems: 'center', gap: 0.5, mt: '2px' }}>
                                <Typography sx={{ fontWeight: 600, fontSize: { xs: 14, sm2: 16 }, color: '#1a1a1a' }}>
                                    {noPrice ? 'نـامـوجـود' : numberFormat((liveData.final_price ?? 0) / 10)}
                                </Typography>
                                {!noPrice && (
                                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: '#8a8a8f' }}>
                                        تومان
                                    </Typography>
                                )}
                            </FlexBox>
                        </Box>
                        {/* {hasDiscount && (
                            <Box sx={{
                                bgcolor: '#fdeaec',
                                color: '#bb202e',
                                fontSize: { xs: 11, sm2: 12 },
                                fontWeight: 700,
                                px: 1,
                                py: 0.5,
                                borderRadius: '6px',
                                flexShrink: 0,
                            }}>
                                %{discountPercent}-
                            </Box>
                        )} */}
                    </FlexBox>
                )}
            </Box>
        </Box>
    )
}

export default ProductCardBody;
